<template>
  <div>
    <button class="btn btn-primary" v-on:click="paste()">{{ messages['paste'] }}</button>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: 'PasteFromClipboard',
  props: [
    'messages',
    'callback'
  ],
  data () {
    return {}
  },
  mounted () {
  },
  unmounted () {
  },
  methods: {
    paste () {
      navigator.clipboard.readText()
        .then(text => {
          this.callback.invokeMethodAsync('SetClipboardTextAsync', text)
        })
      /* .catch(err => {
        console.error('Failed to read clipboard:' + err)
      }) */
    }
  }
}
</script>
